import React from "react";
import { connect } from "react-redux";
import { debug } from "../utils";
// import Breadcrumbs from "./header/Breadcrumbs";
import {
    Shield
} from 'lucide-react';

// Import Refactored Header Components
import UserMenu from "./UserMenu";
import { NotificationLink } from "./header/NotificationLink";
import { ProcessingTasksLink } from "./header/ProcessingTasksLink";
import { FAQLink } from "./header/FAQLink";
import { LogoutButton } from "./LogoutButton";

function Header({ dispatch, pageTitle, firstName, lastName, logoUrl, ticket, currentUser }) {

    return (
        //Added by Cloudsyntax Feb,2026
        <header className="header-v2">
            <div className="header-container">
                <div className="header-flex">
                    {/* Left Section */}
                    <div className="left-section">
                        <div className="branding-area">
                            <div className="icon-box">
                                <Shield className="shield-icon" />
                            </div>
                            <div className="title-area">
                                <h1>{pageTitle}</h1>
                                <p className="subtitle">Home</p>
                            </div>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="right-section">
                        <ProcessingTasksLink />
                        <NotificationLink currentUser={currentUser} />
                        <FAQLink />
                        <UserMenu />
                        <LogoutButton />
                    </div>
                </div>
            </div>
            {/* <Breadcrumbs /> */}
        </header>
    );
}

function mapStateToProps(state) {
    debug("Header mapStateToProps", state);
    // const auth = state.auth;
    return {
        pageTitle: state.layout.pageTitle,
        firstName: state.auth.firstName,
        lastName: state.auth.lastName,
        logoUrl: state.auth.logoUrl,
        ticket: state.auth.access_token,
        currentUser: state.auth
    };
}

export default connect(mapStateToProps)(Header);
